<div class="repeat-form">
  @if (showMinItemsError) {
  <div class="repeat-form-warning" role="alert">{{ minItemsMessage }}</div>
  } @if (props.label) {
  <h3 class="repeat-form-title">{{ props.label }}</h3>
  } @if (props.description) {
  <p class="repeat-form-description">{{ props.description }}</p>
  } @for (row of field.fieldGroup; track row.id; let i = $index) {
  <div class="repeat-form-item">
    <div class="repeat-form-item-text">
      <div class="repeat-form-item-summary">{{ summary(i) }}</div>
      @if (summaryDetail(i)) {
      <div class="repeat-form-item-detail">{{ summaryDetail(i) }}</div>
      }
    </div>
    @if (!props.disabled) {
    <div class="repeat-form-item-actions">
      <button
        matIconButton
        type="button"
        [attr.aria-label]="editText"
        [matTooltip]="editText"
        (click)="editItem(i)"
      >
        <mat-icon>edit</mat-icon>
      </button>
      <button
        matIconButton
        type="button"
        class="repeat-form-remove"
        [attr.aria-label]="removeText"
        [matTooltip]="removeText"
        (click)="removeItem(i)"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </div>
    }
  </div>
  } @if (!props.disabled) {
  <button matButton type="button" class="repeat-form-add" (click)="addItem()">
    <mat-icon>add_circle</mat-icon>
    {{ addText }}
  </button>
  }
</div>
